import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from 'src/app/core/_config/app.config';
import { CustomResponse } from 'src/app/interfaces/CustomResponse';

@Injectable({
    providedIn: 'root',
})
export class CompanyService {
    private API_URL = this.config.urlApi + this.config.versionApi;
    constructor(private http: HttpClient, private config: AppConfig) {}

    GetByTypeId(typeId: number): Observable<any> {
        return this.http.get<CustomResponse<any>>(`${this.API_URL}Company/GetByTypeId?typeId=${typeId}`);
    }
}
